export default __webpack_public_path__ + "static/media/NanumSquareL.3f3fd18b.woff";